import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import Drawer from "@material-ui/core/Drawer/index";
import Divider from "@material-ui/core/Divider/index";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card/index";
import CardHeader from "@material-ui/core/CardHeader/index";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Alert } from "react-bootstrap";
import { FcTreeStructure,FcMultipleDevices } from "react-icons/fc"
import {FaCheckCircle, FaSourcetree} from "react-icons/fa"
import { MdOutlineSupervisorAccount ,MdPlace} from "react-icons/md"
import { BsFillPinAngleFill } from "react-icons/bs"
import {BiExit,BiTime} from "react-icons/bi"


const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#231B88",
  },
});

export default function View(props) {
  const { open, onClose, onSapChoose, chooseSapId } = props;
  const [sap, setSap] = useState({});
  const [structureList, setStructureList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { middleName, name, pin, verify, surname, source, dateTime, status, device, supervisor, devicePlace, inOut, } = sap;




  useEffect(() => {
    setIsLoading(true);
    onSapChoose(chooseSapId)
      .then((res) => {
        setSap(res.data);
        setStructureList(res.data.structureList);

        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [chooseSapId, onSapChoose]);

  const classes = useStyles();

  const Company = structureList.find(item => item.type === "COMPANY")
  const Branch = structureList.find(item => item.type === "BRANCH")
  const Department = structureList.find(item => item.type === "DEPARTMENT")
  const Directorate = structureList.find(item => item.type === "DIRECTORATE")
  const Division = structureList.find(item => item.type === "DIVISION")
  const StructureType = structureList.find(item => item.type === "STRUCTURE_TYPE")


  const sideList = (side) => (
    <div className={classes.list} role="presentation">
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">Biometrik hərəkət hesabatı detalları</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />

      {isLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isLoading && !isError ? (
        <div className="drawer-body">
          <Card className={classes.card}>
          <CardHeader
              title="Ümumi informasiya"
              className="bg-secondary text-dark h6 p-3"
              disableTypography
            />
            <CardHeader
              avatar={
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Address-card.svg"
                  )}
                  className="icon-primary"
                />
              }
              title={`${name} ${surname} ${middleName} `}
              subheader="Ad, soyad, ata adı"
              className="p-3"
            />

            <CardHeader
              avatar={
                <BsFillPinAngleFill
                  className="icon-primary"
                />
              }
              title={pin}
              subheader="Fin kod"
              className="p-3"
            />

            <CardHeader
              avatar={
                <FaCheckCircle
                  className="icon-primary"
                />
              }
              title={verify}
              subheader="Yoxlanış"
              className="p-3"
            />
            <CardHeader
              avatar={
                <MdOutlineSupervisorAccount
                  className="icon-primary"
                />
              }
              title={supervisor}
              subheader="Birbaşa rəhbər"
              className="p-3"
            />
            <CardHeader
              avatar={
                <FaSourcetree
                  className="icon-primary"
                />
              }
              title={source}
              subheader="Mənbə"
              className="p-3"
            />
            <CardHeader
              avatar={
                <FcMultipleDevices
                  className="icon-primary"
                />
              }
              title={device}
              subheader="Qurğu"
              className="p-3"
            />
            <CardHeader
              avatar={
                <MdPlace
                  className="icon-primary"
                />
              }
              title={devicePlace}
              subheader="Qurğu məkanı"
              className="p-3"
            />
            <CardHeader
              avatar={
                <BiExit
                  className="icon-primary"
                />
              }
              title={inOut}
              subheader="Giriş/Çıxış"
              className="p-3"
            />
            <CardHeader
              avatar={
                <BiTime
                  className="icon-primary"
                />
              }
              title={dateTime}
              subheader="Tarix"
              className="p-3"
            />
             {Company &&
              <CardHeader
                avatar={
                  <MdOutlineSupervisorAccount
                    className="icon-primary"
                  />
                }
                title={Company?.name}
                subheader="Şirkət"
                className="p-3"
              />
            }

            {Directorate &&
              <CardHeader
                avatar={
                  <MdOutlineSupervisorAccount
                    className="icon-primary"
                  />
                }
                title={Directorate?.name}
                subheader="Direktorluq"
                className="p-3"
              />
            }

            {Department &&
              <CardHeader
                avatar={
                  <MdOutlineSupervisorAccount
                    className="icon-primary"
                  />
                }
                title={Department?.name}
                subheader="Departament"
                className="p-3"
              />

            }

            {Branch &&
              <CardHeader
                avatar={
                  <MdOutlineSupervisorAccount
                    className="icon-primary"
                  />
                }
                title={Branch?.name}
                subheader="Şöbə"
                className="p-3"
              />
            }

            {Division &&
              <CardHeader
                avatar={
                  <MdOutlineSupervisorAccount
                    className="icon-primary"
                  />
                }
                title={Division?.name}
                subheader="Bölmə"
                className="p-3"
              />
            }
            {StructureType &&

              <CardHeader
                avatar={
                  <MdOutlineSupervisorAccount
                    className="icon-primary"
                  />
                }
                title={StructureType?.name}
                subheader="Struktur növü"
                className="p-3"
              />
            }


            <CardHeader
              avatar={
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Code/Lock-circle.svg")}
                  className="icon-primary"
                />
              }
              title={status === "ACTIVE"
                ? "Aktiv"
                : status === "INACTIVE"
                  ? "Deaktiv"
                  : "-"}
              subheader="Vəziyyət"
              className="p-3"
            />
          </Card>
        </div>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </div>
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      className="drawer--fixed"
    >
      {sideList("right")}
    </Drawer>
  );
}
